import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLoyaltyCard, getLoyaltyProgram, getServices } from '../../services/api';

export const fetchLoyaltyCards = createAsyncThunk(
    'loyaltyCards/fetchCards',
    async ({ perPage, page }, { rejectWithValue }) => {
        try {
            const response = await getLoyaltyCard(perPage, page);
            const data = response.data;
            return {
                cards: data.data || data,
                totalPages: data.last_page,
            };
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch Loyalty Card');
        }
    }
);

export const fetchLoyaltyPrograms = createAsyncThunk(
    'loyaltyCards/fetchPrograms',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getLoyaltyProgram();
            const data = response.data;
            return data.data || data;
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch Loyalty program');
        }
    }
);

export const fetchServices = createAsyncThunk(
    'loyaltyCards/fetchServices',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getServices();
            const data = response.data;
            return data.data || data;
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch Services');
        }
    }
);

const loyaltyCardsSlice = createSlice({
    name: 'loyaltyCards',
    initialState: {
        cards: [],
        programs: [],
        services: [],
        loading: true,
        error: '',
        totalPages: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLoyaltyCards.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchLoyaltyCards.fulfilled, (state, action) => {
                state.cards = action.payload.cards;
                state.totalPages = action.payload.totalPages;
                state.loading = false;
            })
            .addCase(fetchLoyaltyCards.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
            })
            .addCase(fetchLoyaltyPrograms.fulfilled, (state, action) => {
                state.programs = action.payload;
            })
            .addCase(fetchLoyaltyPrograms.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(fetchServices.fulfilled, (state, action) => {
                state.services = action.payload;
            })
            .addCase(fetchServices.rejected, (state, action) => {
                state.error = action.payload;
            });
    },
});

export default loyaltyCardsSlice.reducer;